import type { Task } from '../types';
import { formatDateToLocal } from './date';

/**
 * The XP a task holds RIGHT NOW from its current completion — its own record plus
 * its completed legacy subtasks. Subtask points count only when the parent has a
 * record (unchanged rule, mirrored by every task XP total).
 */
export function taskLivePoints(t: Task): number {
  if (!t.pointRecord) return 0;
  let p = t.pointRecord.points;
  if (t.subTasks) p += t.subTasks.reduce((s, st) => s + (st.pointRecord ? st.pointRecord.points : 0), 0);
  return p;
}

/**
 * ⭐⭐ ALL the XP a task has earned: this round plus every replayed round before
 * it (`retainedPoints`). Every task XP total reads THIS — a total that read only
 * `pointRecord` would lose a folder's XP each time it was replayed.
 */
export function taskEarnedPoints(t: Task): number {
  return taskLivePoints(t) + (t.retainedPoints ?? 0);
}

/**
 * ⭐⭐ ONCE PER DAY (owner, 2026-09-17). A task whose XP was banked by a replay
 * pays again only on a later local day than it last paid — a weekly list pays
 * every week; tick, replay, tick in a loop pays once.
 */
export function mayEarnAgain(t: Task, now: Date = new Date()): boolean {
  if (!t.lastEarnedAt) return true;
  return formatDateToLocal(t.lastEarnedAt) !== formatDateToLocal(now);
}
